import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onMovementsDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onMovementsDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="movement"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onMovementsDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
